import React from 'react';
import styles from './NotFound.module.scss';

export const NotFound = (): JSX.Element => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.errorCode}>404</div>
      <h1 className={styles.title}>Page Not Found</h1>
      <p className={styles.message}>
        Sorry, the page you're looking for doesn't exist or has been moved.
      </p>
      <a href="/" className={styles.btn}>
        Go to Homepage
      </a>
    </div>
  );
};
